import { Button, Box, Text, LinkText } from '@origin-digital/style-guide';
import * as React from 'react';
import analytics from '../../../../analytics';
import { WizardNavigationProps } from './WizardNavigation.types';

const WizardNavigation: React.StatelessComponent<WizardNavigationProps> = ({
  ...props
}: WizardNavigationProps) => {
  const { step, isValid, validating, isLastStep, isSubmitting, previousStep, buttonLabels } = props;

  return (
    <Box>
      <Box direction={'row'} display={'flex'}>
        {!isLastStep && (
          <Box>
            <Button
              data-id="wizardNextButton"
              type="submit"
              text={buttonLabels.next}
              disabled={!isValid || validating}
              onClick={() => {
                analytics.buttonClick('next', 'next');
              }}
            />
          </Box>
        )}

        {isLastStep && (
          <Button
            data-id="wizardSubmitButton"
            type="submit"
            text={buttonLabels.submit}
            disabled={!isValid || validating}
            spinner={isSubmitting}
            onClick={() => {
              analytics.buttonClick('submit', 'Request a quote');
            }}
          />
        )}

        {step > 0 && (
          <Box paddingX={4}>
            <Button
              data-id="wizardBackButton"
              type="button"
              text={buttonLabels.previous}
              kind={'secondary'}
              color={'grey'}
              onClick={() => {
                analytics.buttonClick('back', 'back');
                previousStep();
              }}
            />
          </Box>
        )}
      </Box>
      {isLastStep && (
        <Box marginTop={10}>
          <Text size={'sm'}>
            {
              'To find out more about how Origin collects, uses, holds and discloses your personal and credit information, see our'
            }
            <Box marginLeft={1} display={'inlineBlock'}>
              <LinkText text={'Privacy statements'} href={'/privacy.html'} />
            </Box>
          </Text>
        </Box>
      )}
    </Box>
  );
};

export { WizardNavigation as default };
